export default {
  getTokenSupplyDashboardPage: () => {
    return `/tokenomics/token-supply-dashboard`;
  },
  getBurnDashboardPage: () => {
    return `/tokenomics/burn-dashboard`;
  },
};
